module.exports = __webpack_public_path__ + "static/media/icon_30.1e8aab8f.svg";